import AiBotConversations from "discourse/plugins/discourse-ai/discourse/components/ai-bot-conversations";

export default <template>
  <AiBotConversations @controller={{@controller}} />
</template>
